export enum ToolBarActionType {
  'ACTION_HIDE' = 'core/ACTION_HIDE',
  'ACTION_SHOW' = 'core/ACTION_SHOW',
  'ACTION_TOGGLE' = 'core/ACTION_TOGGLE',
}
